function controllerApproved(total_approved: number, container_1: string, container_2: string, container_3: string, container_4: string, container_5: string) {
  let elements = [container_1, container_2, container_3, container_4, container_5]

  for (let i = 0; i < elements.length; i++) {
    let element = document.getElementById(elements[i])
    if (i < total_approved) {
      element?.classList.add('active')
    } else {
      element?.classList.remove('active')
    }
  }
}

export { controllerApproved }
